<template>
	<v-dialog
		:value="value"
		@input="$emit('input', $event)"
		max-width="520"
		persistent
	>
		<v-card>
			<v-card-title>{{ $t('label.complete-confirm-title') }}</v-card-title>
			<v-card-text>{{ $t('label.complete-confirm-description') }}</v-card-text>
			<v-divider></v-divider>
			<v-card-actions class="justify-end flex-wrap" style="row-gap: 8px;">
				<v-btn text @click="$emit('input', false)">
					{{ $t('button.close') }}
				</v-btn>
				<v-btn color="primary" outlined @click="$emit('dont-share')">
					<v-icon left>task_alt</v-icon>
					{{ $t('button.complete-without-sharing') }}
				</v-btn>
				<v-btn color="primary" @click="$emit('share')">
					<v-icon left>task</v-icon>
					{{ $t('button.complete-and-share') }}
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
export default {
	name: 'CompleteConfirmDialog',
	props: {
		value: {
			type: Boolean,
			required: false,
			default() {
				return false;
			},
		},
	},
};
</script>
